import { useEffect } from 'react'
import { SnackbarProvider } from 'notistack'
import { useTranslation } from 'react-i18next'
import { createBrowserRouter, RouterProvider } from 'react-router'

import DiagnosisPage from './pages/DiagnosisPage'
import ReportPage from './pages/ReportPage'
import { SettingsProvider } from './core/settings'
import useSettings from './core/useSettings'
import ThemeProvider from './theme'
import './App.css'

const router = createBrowserRouter([
  { path: '/', element: <DiagnosisPage /> },
  { path: '/report/:sessionToken', element: <ReportPage /> },
  { path: '*', element: <DiagnosisPage /> },
])

function AppContent() {
  const { mode } = useSettings()
  const { i18n, t } = useTranslation()

  useEffect(() => {
    document.title = t('documentTitle') || APP_TITLE
  }, [i18n.language, t])

  return (
    <ThemeProvider mode={mode}>
      <SnackbarProvider autoHideDuration={3000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <RouterProvider router={router} />
      </SnackbarProvider>
    </ThemeProvider>
  )
}

export default function App() {
  return (
    <SettingsProvider>
      <AppContent />
    </SettingsProvider>
  )
}
